webpackJsonp([49],{

/***/ 344:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(739);

/***/ }),

/***/ 739:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1a7d3778_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_node_modules_vue_markdown_loader_lib_markdown_compiler_js_raw_home_instruction_md__ = __webpack_require__(740);
var normalizeComponent = __webpack_require__(20)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1a7d3778_hasScoped_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_node_modules_vue_markdown_loader_lib_markdown_compiler_js_raw_home_instruction_md__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 740:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('article',[_c('h3',[_vm._v("１）ロゴ画像のアップロード")]),_vm._v(" "),_c('p',[_vm._v("設定を始める前にロゴ画像を用意して、左サイドメニューの「アップロード画像」からアップロードしてください。ロゴ画像の推奨サイズは700x180です。またSEO（検索エンジン最適化）対策のために、サイズが1200x690のOGP画像、600x60のロゴ画像も作成してアップロードしてください。")]),_vm._v(" "),_c('h3',[_vm._v("２）ホームページに必要な企業情報等の設定")]),_vm._v(" "),_c('p',[_vm._v("左サイドメニューの「サイト設定」から、サイトの所有者やSNSアカウント、構造化データ等のSEO（検索エンジン最適化）対策のための情報を入力してください。")]),_vm._v(" "),_c('h3',[_vm._v("３）サイトの基本構造の設定")]),_vm._v(" "),_c('p',[_vm._v("ウェブサイトのベースデザインを左右するナビゲーション（ページ上部）とフッター（ページ下部）、サイドバー（スマホサイズでのサイトナビゲーション）を設定します。左サイドメニューの「サイトテーマ」からそれぞれ採用するコンポーネントを選択してください。選択後に各コンポーネントの設定が終われば、左下のボタンをクリックし、『テーマを保存』をクリックして保存してください。")]),_vm._v(" "),_c('h3',[_vm._v("４）トップページの作成")]),_vm._v(" "),_c('p',[_vm._v("最初にトップページを作成します。左サイドメニューの「固定ページ」の「新規作成」トップページを作成してください。新規作成後、ページ編集ボタンをクリックしてコンテンツを作成してください。作成時には、ページテンプレートを選択し、コンテンツを入力してください。ページテンプレートではなく、コンポーネントを追加することで作成することも可能です。")]),_vm._v(" "),_c('h3',[_vm._v("５）下層ページの作成")]),_vm._v(" "),_c('p',[_vm._v("トップページ以下の下層ページを作成していきます。左サイドメニューの「固定ページ」からページを作成し、必要なコンポーネントを配置してコンテンツを設定してください。")]),_vm._v(" "),_c('h3',[_vm._v("６）投稿の作成")]),_vm._v(" "),_c('p',[_vm._v("投稿を作成するには左サイドメニューの「投稿」から「新規作成」を選んでください。")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

});


// WEBPACK FOOTER //
// static/js/49.26a375b1d2097b79e910.js